import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';
import Checkbox from 'react-simple-checkbox';

import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import LoadingDots from 'src/assets/loading_dots.svg';
import SyncInfo from 'src/ConnectedComponents/Setup/SyncInfo';

import { fetchBlackbaudUsers } from 'src/redux/blackbaudUsers/blackbaudUser.action';
import { getBlackbaudUsers } from 'src/redux/blackbaudUsers/blackbaudUser.selector';
import {
	getAppOrganizations,
	getPendingAppOrganizations,
} from 'src/redux/appOrganizations/appOrganization.selector';
import {
	fetchAppOrganizations,
	requestUpdateAppOrganization,
} from 'src/redux/appOrganizations/appOrganization.action';
import { getPendingAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.selector';
import { requestUpdateAuthOrganization } from 'src/redux/authOrganizations/authOrganization.action';
import { ORG_SETUP_NEEDS_AUTH, ORG_SETUP_NEEDS_SYNC } from 'src/utils/authOrg.constants';
import styles from '../../index.css';
import { Heading, HyperLink, Paragraph, Span, Box } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class ConnectNXT extends Component {
	constructor(props) {
		super(props);
		this.state = {
			connected: false,
		};
	}

	clientId = 'dc03894d-e1dc-4fa9-85a9-91ed35f4a012';

	nxtConnectLink = `https://host.nxt.blackbaud.com/marketplace/applications/${this.clientId}?svcid=renxt`;

	openNxtConnect = () => {
		window.open(this.nxtConnectLink, '_blank');
		this.setState({ connected: true });
	};

	openNxtAuth = () => {
		const bbUriBase = 'https://oauth2.sky.blackbaud.com/authorization';
		const bbUriParams = {
			redirect_uri: `${window.location.origin}/blackbaud_auth_callback`,
			client_id: this.clientId,
			response_type: 'code',
			state: 'fdf80155',
		};
		const bbOauthUri = `${bbUriBase}?${qs.stringify(bbUriParams)}`;
		window.open(bbOauthUri, '_self');
	};

	toggleConnected = () => {
		this.setState({ connected: !this.state.connected });
	};

	async componentDidMount() {
		await this.props.fetchBlackbaudUsers();
		await this.props.fetchAppOrganizations();
		this.setState({ ready: true });
	}

	async componentDidUpdate(prevProps) {
		if (
			this.props.authOrganizations.length &&
			this.props.appOrganizations.length &&
			this.props.currentAuthUser &&
			this.props.blackbaudUsers.length &&
			!this.state.updateRequest
		) {
			this.setState({ updateRequest: true });
			// trigger app server to reset and subscribe to all blackbaud webhooks for this org
			await this.props.requestUpdateAppOrganization(this.props.appOrganizations[0]._id, {
				clear_webhooks: true,
				setup_webhooks: true,
			});
			await this.props.requestUpdateAuthOrganization(this.props.authOrganizations[0]._id, {
				setup_state: ORG_SETUP_NEEDS_SYNC,
			});
		}
	}

	render() {
		if (
			!this.state.ready ||
			this.props.pendingAuthOrganizations.update ||
			this.props.pendingAppOrganizations.update ||
			this.props.authOrganizations.length === 0
		) {
			return <LoadingDots className={styles.SetupLoadingDots} />;
		}

		// return to landing page if auth org in wrong state
		if (this.props.authOrganizations[0].setup_state !== ORG_SETUP_NEEDS_AUTH) {
			return <Redirect to={{ pathname: '/' }} />;
		}

		return (
			<div className={styles.SetupCardLayout}>
				<Heading {...theme.heading.setUpTitle}>Connect NXT</Heading>
				<Box>
					<Paragraph>
						Let’s get Wisely connected and authorized with your Raiser’s Edge NXT
						account.
					</Paragraph>

					<Paragraph>
						Please open the{' '}
						<HyperLink
							href={this.nxtConnectLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							NXT Marketplace
						</HyperLink>{' '}
						and click "Connect" to connect Wisely to your organization.
					</Paragraph>

					<Paragraph>
						Note that you must have “supervisor” permissions in RENXT to proceed.
					</Paragraph>
					<RoundedRectangleButton
						className={styles.DefaultButton}
						fontSize="16px"
						disabledBackgroundColor="#D4D7E4"
						disabled={this.state.connected}
						onClick={this.openNxtConnect}
					>
						Open the NXT Marketplace
					</RoundedRectangleButton>
					<Span cursor="pointer" onClick={this.toggleConnected}>
						<Checkbox checked={this.state.connected} />
						I've connected the Wisely app
					</Span>
					{this.state.connected ? (
						<Box>
							<Paragraph>
								Next, we need to get your authorization for us to sync the data from
								Blackbaud to Wisely.
							</Paragraph>
							<Paragraph>
								You will be redirected back to Wisely after you're done.
							</Paragraph>
							<RoundedRectangleButton
								className={styles.DefaultButton}
								fontSize="16px"
								onClick={this.openNxtAuth}
							>
								Click here to provide your authorization
							</RoundedRectangleButton>
							<SyncInfo />
						</Box>
					) : null}
				</Box>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	appOrganizations: getAppOrganizations(state),
	pendingAppOrganizations: getPendingAppOrganizations(state),
	blackbaudUsers: getBlackbaudUsers(state),
	pendingAuthOrganizations: getPendingAuthOrganizations(state),
});

const actions = {
	fetchBlackbaudUsers,
	fetchAppOrganizations,
	requestUpdateAppOrganization,
	requestUpdateAuthOrganization,
};

ConnectNXT = connect(mapStateToProps, actions)(ConnectNXT);

export default ConnectNXT;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/ConnectCRM/ConnectNXT/index.js